import { ThemeProvider } from 'styled-components';
import { PortalProvider } from 'modules/PortalProvider';
import { ToastProvider } from 'modules/Toast';
import { TooltipProvider } from 'modules/Tooltip/TooltipProvider';
import { InterFontFace } from 'modules/tetrisTheme/typography/InterFontFace';
import { theme } from './theme';
export function TetrisThemeProvider(props) {
    const { children } = props;
    return (<ThemeProvider theme={theme.raw}>
      <theme.GlobalStyle />
      <InterFontFace />
      <PortalProvider />
      <ToastProvider>
        <TooltipProvider>{children}</TooltipProvider>
      </ToastProvider>
    </ThemeProvider>);
}
